export default "__VITE_ASSET__B66PB3sW__"